<template>
  <div v-if="presenter">
    <header class="header text-white bg-info bg-gradient pt-7 pb-3">
      <div class="container pt-5 pb-5">
        <div class="row">
          <div class="col-2">
            <img :src="presenter.user.profile_image_url || '/img/user.png'" :alt="presenter.first_name" class="img-fluid me-5"
            style="width: 100px !important; height: 100px !important;" />
          </div>
          <div class="col">
            <h2 class="text-white">{{ getFullName(presenter) }}</h2>
            <div v-for="appointment in presenter.appointments" :key="appointment.id" class="row">
              <div class="col">
                <SingleAppointment :appointment="appointment" />
              </div>
            </div>

            <div v-if="presenter.short_bio" class="my-3">
              <h5 class="text-white">{{ $t('network.presenters.aboutPresenter') }}:</h5>
              <div v-html="presenter.short_bio"></div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="my-5 container">
      <div v-if="busy" class="text-center">
        <i class="fas fa-5x fa-spinner"></i>
        <p id="cancel-label">{{ $t('network.presenters.fetchingPresenterFeed') }}</p>
      </div>
    </div>
    <div v-if="!busy && presenter" class="container-fluid mt-2">
      <PresenterFeed :presenter="presenter.id" :showPresenterFilter="false" />
    </div>
    <router-link v-slot="{ navigate }" to="/presenters" custom>
      <button id="back_to_presenters" data-test="back_to_presenters" class="btn btn-secondary float-end m-2" @click="navigate">
        <i class="fa fa-arrow-left"></i>
        {{ $t('network.presenters.bactToPresenters') }}
      </button>
    </router-link>

    <div class="clearfix"></div>
  </div>
</template>
<script>
import PresenterFeed from '../media/feed/';
import SingleAppointment from '@/components/commons/Presenters/Appointment.vue';

export default {
  name: 'NetworkPresenter',
  components: {
    PresenterFeed,
    SingleAppointment,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      busy: true,
      presenter: null,
      media: null,
    };
  },
  watch: {
    id(newV) {
      if (newV != this.presenter.id) this.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    // check the route parameter and the store, and refresh it if needed
    refresh() {
      if (this.presenter == null || this.presenter.id != this.id) {
        // refresh it!
        this.busy = true;
        this.$http.get('presenters/' + this.id).then(resp => {
          this.presenter = resp.data;
          this.busy = false;
        });
        this.$http.get('presenters/' + this.id).then(resp => {
          this.presenter = resp.data;
          this.busy = false;
        });
      }
    },
    getFullName(presenter) {
      let name = '';
      if (presenter.user) {
        if (presenter.user.prefix) name += presenter.user.prefix + ' ';
        name += presenter.user.first_name + ' ' + presenter.user.last_name;
        if (presenter.user.suffix) name += ', ' + presenter.user.prefix;
      } else {
        name = presenter.text;
      }
      return name;
    },
  },
};
</script>
<style>
.nav-tabs-large > div > ul.nav-tabs > li.nav-item > a.nav-link {
  font-size: 110%;
  padding: 0px 60px !important;
}
</style>